import React, { FC, useState, useEffect, useContext } from 'react'
import { notify } from 'react-notify-toast'
import { usePromiseTracker, trackPromise } from 'react-promise-tracker'
import history from '../../history'
import { isMobile } from 'react-device-detect'

import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
import NavigationBar from '../NavigationBar/NavigationBar'

import { getUserData, getUserFeed } from '../../Api/backendApi'
import AppContext from '../../context/appContext'

import NewEntry from './views/NewEntry'
import MainView from './views/MainView'
import EntryShowcase from './views/EntryShowcase'
import CompareEntries from './views/CompareEntries'
import GenericBackButton from '../../GenericComponents/GenericBackButton'
import GenericMobileTopNavigation from '../../GenericComponents/GenericMobileTopNavigation'
// import { MobileTopNavigation } from './style/ProgressScreenStyle'
// import GenericMobileTopNavigation from '../../GenericComponents/GenericMobileTopNavigation'

import Loader from '../Loader/Loader'
import GenericIcon from '../../GenericComponents/GenericIcon'

import SwitchToLightThemeIcon from '../../assets/REDESIGN_Assets/theme/switch-to-light-theme-icon.svg'
import SwitchToDarkThemeIcon from '../../assets/REDESIGN_Assets/theme/switch-to-dark-theme-icon.svg'

interface ProgressScreenInterface {}

const ProgressScreen: FC<ProgressScreenInterface> = ({}) => {
  const appContext = useContext(AppContext)
  const [feeds, setFeeds] = useState(Object)
  const [user, setUser] = useState(Object)
  const [isDemoMode, setDemoMode] = useState(false)
  const [progressMode, setProgressMode] = useState(0)
  const [clickedFeedData, setClickedFeedData] = useState(Object)
  const [newEntryDimensions, setNewEntryDimensions] = useState({
    hip_circumference: 0,
    belly_circumference: 0,
    thigh_circumference: 0,
  })
  const [newEntryProgress, setNewEntryProgress] = useState(0)
  const [addEntryMode, setAddEntryMode] = useState(false)
  const [progressShowCaseMode, setProgressShowCaseMode] = useState(false)
  const [progressMainPageMode, setProgressMainPageMode] = useState(true)
  const [progressCompareMode, setProgressCompareMode] = useState(false)
  const [oldestFeedWithPhotos, setOldestFeedWithPhotos] = useState()
  const [activePhoto, getActivePhoto] = useState('F')

  const { promiseInProgress } = usePromiseTracker()

  useEffect(() => {
    obtainUser()
    obtainFeeds(false)

    // on unmount action change progress mode to allow child component always render data
    return () => {
      setProgressMode(0)
    }
  }, [])

  useEffect(() => {
    if (user && user.id) {
      setDemoMode(!user.has_subscription)
    }
  }, [user])

  useEffect(() => {
    if (feeds.length) {
      gatherOldestFeedWithPhotos()
    }
  }, [feeds])

  const gatherOldestFeedWithPhotos = () => {
    let min: any = null
    // gather all feeds with photos and
    let feedsWithPhotos = feeds.filter((feed: any) => feed.photos.length)

    // pick oldest feed with photos

    if (feedsWithPhotos.length) {
      min = feedsWithPhotos.reduce((a: any, b: any) => {
        return a.creation_datetime < b.creation_datetime ? a : b
      })
    }

    setOldestFeedWithPhotos(min)
  }

  const obtainUser = async () => {
    if (appContext.appState.user) {
      setUser(appContext.appState.user)
    }

    const user = await trackPromise(getUserData())
    setUser(user)
    appContext.updateAppState('user', user)
  }

  const obtainFeeds = async (reload: boolean) => {
    if (appContext.appState.feeds && !reload) {
      setFeeds(appContext.appState.feeds)
      setProgressMode(1)
    }

    if (reload) {
      const feeds = await trackPromise(getUserFeed())
      setFeeds(feeds)
      appContext.updateAppState('feeds', feeds)
      setProgressMode(1)
    } else {
      const feeds = await trackPromise(getUserFeed())
      setFeeds(feeds)
      appContext.updateAppState('feeds', feeds)
      setProgressMode(1)
    }
  }

  const updateClickedData = (data: any) => {
    setClickedFeedData(data)
  }

  const handleChangeProgressMode = (e: any) => {
    setProgressMode(parseInt(e.target.id))
    setClickedFeedData({})
    if (e.target.classList.contains('active')) {
      return
    } else {
      const allElements = Array.from(
        document.getElementsByClassName('goal-option')
      )

      allElements &&
        allElements.forEach((element: any) => {
          element.classList.contains('active') &&
            element.id !== e.target.id &&
            element.classList.remove('active')
        })
      e.target.classList.add('active')
    }
  }

  const handleNewEntryData = (mode: string, value: number) => {
    switch (mode) {
      case 'belly':
        setNewEntryDimensions({
          ...newEntryDimensions,
          belly_circumference: value,
        })
        break
      case 'thigh':
        setNewEntryDimensions({
          ...newEntryDimensions,
          thigh_circumference: value,
        })
        break

      case 'hip':
        setNewEntryDimensions({
          ...newEntryDimensions,
          hip_circumference: value,
        })
        break
      default:
        break
    }
  }

  const handleProgressNewEntry = () => {
    switch (newEntryProgress) {
      case 0:
        if (
          newEntryDimensions.belly_circumference < 20 ||
          newEntryDimensions.belly_circumference > 300 ||
          newEntryDimensions.belly_circumference == 0
        ) {
          notify.show(`Musisz uzupełnić obwód brzucha`, 'error', 3000)
          return
        } else {
          setNewEntryProgress(newEntryProgress + 1)
        }
        break
      case 1:
        if (
          newEntryDimensions.hip_circumference == 0 ||
          newEntryDimensions.hip_circumference > 300 ||
          newEntryDimensions.hip_circumference < 20
        ) {
          notify.show(`Musisz uzupełnić obwód bioder`, 'error', 3000)
          return
        } else {
          setNewEntryProgress(newEntryProgress + 1)
        }
        break
      case 2:
        if (
          newEntryDimensions.thigh_circumference == 0 ||
          newEntryDimensions.thigh_circumference > 300 ||
          newEntryDimensions.thigh_circumference < 20
        ) {
          notify.show(`Musisz uzupełnić obwód ud`, 'error', 3000)
          return
        } else {
          setNewEntryProgress(newEntryProgress + 1)
        }
        break
    }
  }

  const handleGoToAddNewEntry = () => {
    setProgressMainPageMode(false)
    setAddEntryMode(true)
    setProgressShowCaseMode(false)
    setProgressCompareMode(false)
  }

  const handleGoToMainPage = (reload: boolean) => {
    if (reload) {
      obtainFeeds(true)
    }
    setProgressMainPageMode(true)
    setAddEntryMode(false)
    setProgressShowCaseMode(false)
    setProgressCompareMode(false)
  }

  const handleGoBackToMainPageEntryFromAddNewEntry = () => {
    setProgressMainPageMode(true)
    setAddEntryMode(false)
  }

  const handleGoToCompare = () => {
    setProgressMainPageMode(false)
    setAddEntryMode(false)
    setProgressShowCaseMode(false)
    setProgressCompareMode(true)
  }

  const handleGoToShowcase = () => {
    setProgressMainPageMode(false)
    setProgressShowCaseMode(true)
  }

  return (
    <GenericBackgroundLayer
      className={`${
        appContext.appState.theme == 'light' ? 'light' : 'standard'
      } link-button progress-screen`}
      justify="flex-start"
      fDir={'column'}
      align={'center'}
    >
      <NavigationBar
        isPlayerView={false}
        backButtonAction={
          !progressMainPageMode
            ? () => handleGoToMainPage(false)
            : () => history.push('/trening')
        }
      />
      {isMobile && (
        <GenericMobileTopNavigation
          isPlayerView={false}
          dietCartClick={null}
          handleClick={
            !progressMainPageMode
              ? () => handleGoToMainPage(false)
              : () => history.push('/trening')
          }
        />
        // <MobileTopNavigation>
        //   <GenericBackButton
        //     style={{}}
        //     handleClick={
        //       !progressMainPageMode
        //         ? () => handleGoToMainPage()
        //         : () => history.push('/trening')
        //     }
        //   />
        //   <GenericIcon
        //     src={
        //       appContext.appState.theme == 'dark'
        //         ? SwitchToLightThemeIcon
        //         : SwitchToDarkThemeIcon
        //     }
        //     width={'5vw'}
        //     height={'5vw'}
        //     margin={'0 7% 0 0'}
        //   />
        // </MobileTopNavigation>
      )}

      {progressMainPageMode && (
        <MainView
          handleChangeProgressMode={handleChangeProgressMode}
          clickedFeedData={clickedFeedData}
          feeds={feeds}
          progressMode={progressMode}
          updateClickedData={updateClickedData}
          setAddEntryMode={handleGoToAddNewEntry}
          handleGoToShowcase={handleGoToShowcase}
        />
      )}

      {addEntryMode && (
        <NewEntry
          handleNewEntryData={handleNewEntryData}
          handleProgressNewEntry={handleProgressNewEntry}
          newEntryProgress={newEntryProgress}
          newEntryDimensions={newEntryDimensions}
          setAddEntryMode={setAddEntryMode}
          handleGoToMainPage={handleGoToMainPage}
        />
      )}
      {progressShowCaseMode && (
        <EntryShowcase
          clickedFeedData={clickedFeedData}
          oldestFeedWithPhotos={oldestFeedWithPhotos}
          handleGoToCompare={handleGoToCompare}
          handleGoToMainPage={handleGoToMainPage}
          getActivePhoto={getActivePhoto}
        />
      )}
      {progressCompareMode && (
        <CompareEntries
          clickedFeedData={clickedFeedData}
          oldestFeedWithPhotos={oldestFeedWithPhotos}
          feeds={feeds}
          activePhoto={activePhoto}
        />
      )}
      {promiseInProgress &&
        (!appContext.appState.user || !appContext.appState.feeds) && <Loader />}
    </GenericBackgroundLayer>
  )
}

export default ProgressScreen
